export default __webpack_public_path__ + "static/media/img_hakim.d474dbd2.png";